import { getDefaultMargin, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const DividerDesignSettings = {
  'divider-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'divider-design-line-thickness': {
    phone: ['1px'],
    'phone-landscape': ['1px'],
    tablet: ['1px'],
    'tablet-landscape': ['1px'],
    desktop: ['1px'],
    tv: ['1px'],
  },
  'divider-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  // Alignment
  'divider-design-text-alignment': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'divider-design-component-alignment': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  // Variant
  'divider-design-text-style': {
    phone: 'normal',
    'phone-landscape': 'normal',
    tablet: 'normal',
    'tablet-landscape': 'normal',
    desktop: 'normal',
    tv: 'normal',
  },
  // Typography
  'accordion-design-title-typography': {
    phone: getDefaultTypography('Body Medium'),
    'phone-landscape': getDefaultTypography('Body Medium'),
    tablet: getDefaultTypography('Body Medium'),
    'tablet-landscape': getDefaultTypography('Body Medium'),
    desktop: getDefaultTypography('Body Medium'),
    tv: getDefaultTypography('Body Medium'),
  },
  'divider-design-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'divider-design-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'divider-design-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'divider-design-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'divider-design-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
}
